import { useRef } from "react";
import "../../../css/DesignSystem/Upload/FileUpload.css";
import {ReactComponent as UploadIcon} from '../../../assets/icons/upload-icon.svg';

const FileUpload = ({
  label,
  description = "Drag & drop files here or",
  browseText = "Browse",
  status = "default",
  statusMessage,
  fileName,
  files = [],
  accept,
  multiple = false,
  onBrowse,
  onFilesChange,
  onDrop,
  onRemove,
  disabled = false,
  isRequired
}) => {
  const inputRef = useRef(null);

  const emitFiles = (incomingFiles) => {
    if (!incomingFiles) return;
    const nextFiles = Array.from(incomingFiles);
    onFilesChange?.(multiple ? nextFiles : nextFiles[0]);
  };

  const handleBrowse = () => {
    if (disabled) return;
    if (onBrowse) {
      onBrowse();
      return;
    }
    inputRef.current?.click();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    if (disabled) return;
    onDrop?.(event);
    emitFiles(event.dataTransfer?.files);
  };

  const handleInputChange = (event) => {
    emitFiles(event.target.files);
    event.target.value = "";
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const derivedFileName =
    fileName || (!multiple && files?.length === 1 ? files[0]?.name : "");

  return (
    <div className="ds-upload">
      {label && <div className="FP_Content text-black">{label}<span className="text-error">{isRequired? "*":""}</span></div>}
      {accept && (
        <div className="FP_Help_Text">
          Acceptable file types: {accept.split(",").join(", ")}
        </div>
      )}
      <div
        className={`ds-upload-dropzone ds-upload-dropzone--${status} ${
          disabled ? "ds-upload-dropzone--disabled" : ""
        }`}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        <div className="ds-upload-row">
          <div className="ds-upload-icon" aria-hidden>
            <UploadIcon />
          </div>
          <div className="ds-upload-text">
            <div className="FP_Content primary">{description}</div>
            <button
              type="button"
              className="ds-upload-browse FP_Content_Semibold"
              onClick={handleBrowse}
              disabled={disabled}
            >
              {browseText}
            </button>
          </div>
          {/* {derivedFileName && onRemove && (
            <button
              type="button"
              className="ds-upload-remove FP_Content_Semibold"
              onClick={onRemove}
              aria-label="Remove file"
            >
              ×
            </button>
          )} */}
        </div>
        {statusMessage && (
          <div
            className={`ds-upload-status ds-upload-status--${status} FP_Help_Text_Semibold`}
          >
            {statusMessage}
          </div>
        )}
        {/* {derivedFileName && (
          <div className="ds-upload-filename">{derivedFileName}</div>
        )} */}
      </div>
      <input
        ref={inputRef}
        type="file"
        className="ds-upload-input"
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={handleInputChange}
      />
    </div>
  );
};

export default FileUpload;
